import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {translate} from "react-i18next";
import $ from 'jquery';

@translate(['dashboard'], {wait:true})
class ProgressCircle extends Component {
  componentWillUpdate(nextProps) {
    const {noRides, statistics} = this.props;
    if (statistics.score !== nextProps.statistics.score || statistics.deviceId !== nextProps.statistics.deviceId) {
      const _this = $(this.refs.progressCircle);
      $({ n: 0 }).stop(true, true).animate({ n: nextProps.statistics.score }, { duration: 800, step: function(a) { _this.attr('data-progress', a | 0); } });
    }
  }

  componentDidMount() {
    const {noRides} = this.props;
    if (!noRides) {
      const _this = $(this.refs.progressCircle);
      const _thisLimit = _this.data('progress');
      $({ n: 0 }).stop(true, true).animate({ n: _thisLimit }, { duration: 800, step: function(a) { _this.attr('data-progress', a | 0); } });
    }
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.statistics.score === nextProps.statistics.score
      && this.props.isStatisticsLoaded === nextProps.isStatisticsLoaded
      && this.props.statistics.deviceId === nextProps.statistics.deviceId
      && this.props.currentLanguage === nextProps.currentLanguage) return false;
    return true;
  }

  render() {
    const {t, statistics, isStatisticsLoaded} = this.props;
    const score = Number(statistics.score) || 0;
    const hasScore = statistics.score !== "NaN" && statistics.score !== undefined;
    return (
      <div className="progress-circle__statistics">
        <span ref="progressCircle" className="progress-circle progress-circle-animate" data-progress={score}>
          <span><em></em></span><span><em></em></span>
        </span>
        {get_sign_for_score(score,t)}
        {/*<i className={!hasScore ? 'no-rides' : ''}>{hasScore || !isStatisticsLoaded ? t('dashboard:points_out_of_100') : t('dashboard:no-rides')}</i>*/}
        {/*<i className={!hasScore ? 'no-rides' : ''}>{hasScore || !isStatisticsLoaded ? t('dashboard:points_out_of_100') : t('dashboard:no-rides')}</i>*/}
      </div>
    );
  }
}


function get_sign_for_score(score,t){
  let color = '';
  let word = '';
  switch (true){
    case score > 79:
      color = "#00DBAA"
      word = t('dashboard:word_score_excellent')
      break;
    case score > 59 && score < 80:
      color = "#69D313"
      word = t('dashboard:word_score_good')
      break;
    case score > 39 && score < 60:
      color = "#FA9231"
      word = t('dashboard:word_score_normal')
      break;
    case score > 0 && score < 40:
      color = "#FD3514"
      word = t('dashboard:word_score_bad')
      break;
  }

  return <i style={{color: color,fontWeight: "bold"}}>{word}</i>

}

ProgressCircle.propTypes = {
  // noRides: PropTypes.bool,
  statistics: PropTypes.object,
};

export default connect(
  (state) => {
    return {
      // noRides: state.rides.journeys.length === 0  && state.rides.areJourneysLoaded,
      isStatisticsLoaded: state.statistics.isStatisticsLoaded,
      statistics: state.statistics.statistics.filter(item => item.deviceId === state.devices.currentDevice.id).pop() || {},
      currentLanguage: state.langs.currentLanguage
    };
  },
  () => ({}),
)(ProgressCircle);



// WEBPACK FOOTER //
// ./src/components/Dashboard/ProgressCircle.js